// extracted by mini-css-extract-plugin
export default {"titles":"BookTable_titles__MMOxq","titles1":"BookTable_titles1__CXJaN","titles2":"BookTable_titles2__GGBoa","grid":"BookTable_grid__CT54u"};